<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { renderSiteNav } from '../site/chrome'

const { t, locale } = useI18n()

// The page's own path, to mark the current section. Read once: switching language
// changes only the prefix, never the section.
const path = typeof window === 'undefined' ? '/' : window.location.pathname

// Shared with the static pages, so both surfaces emit identical markup.
const html = computed(() =>
  renderSiteNav((key, params) => t(key, params ?? {}), locale.value, path),
)
</script>

<template>
  <!-- Built from catalog strings, escaped by the renderer; never user input. -->
  <div class="site-nav-host" v-html="html" />
</template>
